"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnDeclarationResponseToJSON = exports.ReturnDeclarationResponseFromJSONTyped = exports.ReturnDeclarationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReturnDeclarationResponseFromJSON(json) {
    return ReturnDeclarationResponseFromJSONTyped(json, false);
}
exports.ReturnDeclarationResponseFromJSON = ReturnDeclarationResponseFromJSON;
function ReturnDeclarationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.ReturnDeclarationInlineErrorFromJSON)(json['errors']),
    };
}
exports.ReturnDeclarationResponseFromJSONTyped = ReturnDeclarationResponseFromJSONTyped;
function ReturnDeclarationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'errors': (0, _1.ReturnDeclarationInlineErrorToJSON)(value.errors),
    };
}
exports.ReturnDeclarationResponseToJSON = ReturnDeclarationResponseToJSON;
//# sourceMappingURL=ReturnDeclarationResponse.js.map